"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPersonalProductsListDetailPage = void 0;
var _auth = require("@ori/auth");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _productBox = require("@ori/product-box");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _getProductListingPageData = require("./getProductListingPageData");
/* istanbul ignore file */ const getPersonalProductsListDetailPage = async (param)=>{
    let { atpClusterId, backendOnlyTrustedToken, customerTypeId, globalApiUrl, language, pageId, productListId, staticApiUrl, tenant, token } = param;
    const globalApiClient = new _globalApiClientReact.ApiClient({
        baseUrl: globalApiUrl,
        language,
        tenant,
        token
    });
    const globalApiClientWithTrustedToken = new _globalApiClientReact.ApiClient({
        baseUrl: globalApiUrl,
        language,
        tenant,
        token: backendOnlyTrustedToken
    });
    const staticApiClient = new _staticApiClientReact.ApiClient({
        baseUrl: staticApiUrl,
        language,
        tenant
    });
    const [{ breadcrumbs }, { data: { customerId, items } }, hideRating, { data: productBoxConfiguration }] = await Promise.all([
        (0, _getProductListingPageData.getProductListingPageData)({
            language,
            staticApiUrl,
            tenant,
            pageId
        }),
        (0, _globalApiClientReact.getProductListTypeProductList)(globalApiClient, 'Personal', productListId, {
            [_fetching.TENANT_CONTEXT]: tenant
        }),
        (0, _productBox.resolveHideRating)({
            staticApiUrl,
            tenant
        }),
        (0, _staticApiClientReact.getTenantApplicationsProductboxConfiguration)(staticApiClient, tenant)
    ]);
    const productCodes = items.map((param)=>{
        let { itemCode } = param;
        return itemCode;
    }).filter((itemCode)=>!!itemCode);
    const [{ data: { firstName, lastName } }, { data: { data: productBoxData } }] = await Promise.all([
        (0, _globalApiClientReact.getCustomerProfile)(globalApiClientWithTrustedToken, customerId !== null && customerId !== void 0 ? customerId : _auth.NOT_LOGGED_IN_USER_ID, {
            [_fetching.TENANT_CONTEXT]: tenant
        }),
        productCodes.length > 0 ? (0, _staticApiClientReact.getTenantApplicationsProductBox)(staticApiClient, tenant, {
            lang: language,
            productCodes,
            atpClusterId,
            customerTypeId
        }) : Promise.resolve({
            data: {
                data: null
            }
        })
    ]);
    var _productBoxData_products;
    const products = (0, _productBox.mapProductBoxesFromStaticApi)({
        data: (_productBoxData_products = productBoxData === null || productBoxData === void 0 ? void 0 : productBoxData.products) !== null && _productBoxData_products !== void 0 ? _productBoxData_products : [],
        isAnonymousUser: customerTypeId === 0
    });
    return {
        breadcrumbs,
        firstName: firstName !== null && firstName !== void 0 ? firstName : null,
        productBoxConfiguration: {
            ...productBoxConfiguration,
            isRatingsAndReviewsEnabled: productBoxConfiguration.isRatingsAndReviewsEnabled || !hideRating
        },
        lastName: lastName !== null && lastName !== void 0 ? lastName : null,
        products
    };
};
exports.getPersonalProductsListDetailPage = getPersonalProductsListDetailPage;
